import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EndPointApi } from '@helpers/endpointapi';
import { CeuUnit } from 'icreate/common/models/ceu-unit';
import { FcuUnit, FcuUnitFull, FcuUnitPayload, FcuUnitAliases } from 'icreate/common/models/fcu-unit';
import { FuUnit } from 'icreate/common/models/fu-unit';
import { lastValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class FcuUnitServiece {
    private domain: string;
    private headers: any = new HttpHeaders({
        'Content-Type': 'application/json',
    });

    constructor(private http: HttpClient) {
        this.domain = EndPointApi.iApiDomain();
    }

    async getList(vesselId: string) {
        return await lastValueFrom(
            this.http.get<FcuUnit[]>(`${this.domain}/api/fcuUnit`, {
                headers: this.headers,
                params: { vesselId },
            })
        );
    }

    async getFcuWithFuAndCeu(vesselId: string) {
        return await lastValueFrom(
            this.http.get<(FcuUnit & { fuUnitList: FuUnit[]; ceuUnitList: CeuUnit[] })[]>(
                `${this.domain}/api/fcuUnit/device-list`,
                {
                    headers: this.headers,
                    params: { vesselId },
                }
            )
        );
    }

    async getByFcuId(fcuId: string) {
        return await lastValueFrom(
            this.http.get<FcuUnitPayload>(`${this.domain}/api/fcuUnit/${fcuId}`, {
                headers: this.headers,
            })
        );
    }

    async create(fcuUnitData: FcuUnitPayload) {
        return await lastValueFrom(
            this.http.post<FcuUnit>(`${this.domain}/api/fcuUnit`, fcuUnitData, {
                headers: this.headers,
            })
        );
    }

    async duplicateFcuUnit(fcuUnitId: string) {
        return await lastValueFrom(
            this.http.post<FcuUnit>(
                `${this.domain}/api/fcuUnit/copy`,
                { fcuUnitId },
                {
                    headers: this.headers,
                }
            )
        );
    }

    async update(fcuUnitData: FcuUnitPayload) {
        return await lastValueFrom(
            this.http.put<FcuUnit>(`${this.domain}/api/fcuUnit/${fcuUnitData.id}`, fcuUnitData, {
                headers: this.headers,
            })
        );
    }

    async getUpdatedFcuUnitFull(fcuUnitId: string, include: FcuUnitAliases[]) {
        return await lastValueFrom(
            this.http.get<FcuUnitFull>(`${this.domain}/api/fcuUnit/socket/updated/${fcuUnitId}`, {
                params: {
                    include: this.parseIncludeStr(include),
                },
            })
        );
    }

    async getFcuUnitFull(fcuUnitId: string, include: FcuUnitAliases[]) {
        return await lastValueFrom(
            this.http.get<FcuUnitFull>(`${this.domain}/api/fcuUnit/full/${fcuUnitId}`, {
                params: {
                    include: this.parseIncludeStr(include),
                },
            })
        );
    }

    async deleteFcuUnit(fcuUnitId: string) {
        return await lastValueFrom(this.http.delete(`${this.domain}/api/fcuUnit/${fcuUnitId}`));
    }

    private parseIncludeStr(include: FcuUnitAliases[]): string {
        return include.reduce((prev, alias) => {
            if (!prev) {
                return alias;
            } else {
                return `${prev},${alias}`;
            }
        }, '');
    }
}
